import React from "react";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "../ui/chart";
import { ContentType as TooltipContentType } from "recharts/types/component/Tooltip";
import { AccentColor } from "@/helpers/types";

import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";
import { Card, CardContent, CardHeader } from "../ui/card";
import {
  Cell,
  Pie,
  PieChart,
  PolarRadiusAxis,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
} from "recharts";
import { BiEdit, BiSolidHelpCircle } from "react-icons/bi";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../ui/hover-card";

const RadialChart: React.FC<{
  t: any;
  backtestGraphRes: any;
  title: string;
  hint?: string;
  totalTrades?: number;
}> = ({ title, t, backtestGraphRes = {}, hint, totalTrades = null }) => {
  const CustomTooltip: TooltipContentType<ValueType, NameType> = ({
    active,
    payload,
  }) => {
    if (active && payload && payload.length) {
      return (
        <div className="flex flex-col gap-2 text-sm bg-background text-foreground border rounded shadow-sm p-2">
          {payload[0].payload.name}: {payload[0].value}
          {totalTrades && "%"}
        </div>
      );
    }
    return null;
  };
  //
  let backtestGraphResModified =
    backtestGraphRes.length > 1
      ? [
          {
            [backtestGraphRes[0]?.name]: backtestGraphRes[0]?.value,
            [backtestGraphRes[1]?.name]: backtestGraphRes[1]?.value,
          },
        ]
      : [];

  return (
    <div className="w-full h-full radialChartMarketplace">
      <CardHeader className=" items-center text-sm text-center font-semibold tracking-tight pt-0 pb-0 h-[20%]">
        <div className="text-[12px] flex items-center mt-0 pt-0">
          {title}
          {hint && (
            <HoverCard openDelay={100}>
              <HoverCardTrigger asChild>
                <span>
                  <BiSolidHelpCircle size={12} />
                </span>
              </HoverCardTrigger>
              <HoverCardContent>{hint}</HoverCardContent>
            </HoverCard>
          )}
        </div>
      </CardHeader>

      <CardContent className="flex flex-col p-0  items-center mt-[5%]">
        <div className="flex w-full h-full">
          <ChartContainer
            config={{}}
            // className="mx-auto aspect-square w-full max-w-[250px]"
            // className="w-full h-full aspect-auto h-[180px]"
            className="w-full h-full"
          >
            {/* <ResponsiveContainer width={'80%'} > */}
            <RadialBarChart
              data={backtestGraphResModified}
              startAngle={180}
              endAngle={0}
              // innerRadius={"100%"}
              innerRadius={"90%"}
              outerRadius={"160%"}
            >
              <ChartTooltip
                cursor={false}
                // content={<ChartTooltipContent hideLabel />}
                content={
                  <ChartTooltipContent hideLabel className="percentage" />
                }
              />
              <PolarRadiusAxis tick={false} tickLine={false} axisLine={false} />

              <text
                x="50%"
                y="41%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="fill-foreground text-sm font-bold"
              >
                {totalTrades
                  ? totalTrades
                  : backtestGraphRes?.reduce(
                      (item: any, acc: any) => item.value + acc.value
                    )}
                <tspan
                  x="50%"
                  dy="1.5em"
                  className="fill-muted-foreground text-sm"
                >
                  {t("Total Trades")}
                </tspan>
              </text>

              <RadialBar
                dataKey={backtestGraphRes[0]?.name} // Make sure this data key matches your data
                cornerRadius={3} // Rounded corners
                fill={AccentColor.GREEN} // Use your preferred color
                className=""
                stackId="a"
              />
              <RadialBar
                dataKey={backtestGraphRes[1]?.name} // Make sure this data key matches your data
                cornerRadius={3} // Rounded corners
                fill="var(--foreground-red)" // Use your preferred color
                // className="stroke-transparent stroke-2"
                className=""
                stackId="a"
              />
            </RadialBarChart>
            {/* </ResponsiveContainer> */}
          </ChartContainer>
        </div>
      </CardContent>
    </div>
  );
};
export default RadialChart;
